module.exports = __webpack_public_path__ + "media/images/dmc/dmc_service-02-3f6b976f2438e053b1d9a18f701c8125.jpg";